import React from "react";
import icon01d from "./icons/01d.png";
import icon01n from "./icons/01n.png";
import icon02d from "./icons/02d.png";
import icon02n from "./icons/02n.png";
import icon03d from "./icons/03d.png";
import icon03n from "./icons/03n.png";
import icon04d from "./icons/04d.png";
import icon04n from "./icons/04n.png";
import icon09d from "./icons/09d.png";
import icon09n from "./icons/09n.png";
import icon10d from "./icons/10d.png";
import icon10n from "./icons/10n.png";
import icon11d from "./icons/11d.png";
import icon11n from "./icons/11n.png";
import icon13d from "./icons/13d.png";
import icon13n from "./icons/13n.png";
import icon50d from "./icons/50d.png";
import icon50n from "./icons/50n.png";
//import ReactAnimatedWeather from "react-animated-weather";

export default function WeatherIcon(props) {
  const codeMapping = {
    "01d": icon01d,
    "01n": icon01n,
    "02d": icon02d,
    "02n": icon02n,
    "03d": icon03d,
    "03n": icon03n,
    "04d": icon04d,
    "04n": icon04n,
    "09d": icon09d,
    "09n": icon09n,
    "10d": icon10d,
    "10n": icon10n,
    "11d": icon11d,
    "11n": icon11n,
    "13d": icon13d,
    "13n": icon13n,
    "50d": icon50d,
    "50n": icon50n,
  };

  return (
    <img src={codeMapping[props.code]} alt={props.alt} height={props.size} />

    // <ReactAnimatedWeather
    // icon={codeMapping[props.code]}
    // color="#1e1e1e"
    // size={props.size}
    //  animate={true}
    // />
  );
}
